import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Support from './pages/Support';
import Invite from './pages/Invite';
import OpenSource from './pages/OpenSource';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/invite/:path" element={<Invite />} />
          <Route path="/opensource" element={<OpenSource />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
